// extracted by mini-css-extract-plugin
export default {"AssignDiscipline":"AssignDiscipline_AssignDiscipline__IdAPO","modalBody":"AssignDiscipline_modalBody__ZmJqt","list":"AssignDiscipline_list__ENAmB"};